export const authTraductions = {
    en: {
        emailOrPseudo: 'Email ou pseudo :',
        login: 'Se connecter',
        logining: 'Connexion...',
        password: 'Mot de passe : ',
    },
    fr: {
        emailOrPseudo: 'Email ou pseudo :',
        login: 'Se connecter',
        logining: 'Connexion...',
        password: 'Mot de passe : ',
    }
}